var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataSourceIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 7656"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11.9993C0 11.263 0.596954 10.666 1.33333 10.666H28C28.7364 10.666 29.3333 11.263 29.3333 11.9993C29.3333 12.7357 28.7364 13.3327 28 13.3327H1.33333C0.596954 13.3327 0 12.7357 0 11.9993Z",
    fill: "#BCAB79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.32 0L21.0133 1.58946e-07C21.7575 0.000395219 22.4875 0.208377 23.12 0.600559C23.7518 0.992398 24.262 1.55259 24.5932 2.21824C24.5935 2.21883 24.5937 2.21941 24.594 2.22L29.1922 11.403C29.285 11.5883 29.3333 11.7927 29.3333 12V20C29.3333 21.0609 28.9119 22.0783 28.1618 22.8284C27.4116 23.5786 26.3942 24 25.3333 24H4C2.93913 24 1.92172 23.5786 1.17157 22.8284C0.421427 22.0783 0 21.0609 0 20V12C0 11.7927 0.0483152 11.5883 0.14111 11.403L4.73929 2.22C4.73962 2.21935 4.73994 2.2187 4.74026 2.21805C5.07144 1.55248 5.58156 0.992359 6.21338 0.600559C6.84582 0.208377 7.57583 0.000394901 8.32 0ZM8.32045 2.66667C8.07248 2.66685 7.82948 2.73617 7.61874 2.86685C7.40792 2.99758 7.23776 3.18453 7.12737 3.40667L7.12556 3.41031L2.66667 12.3152V20C2.66667 20.3536 2.80714 20.6928 3.05719 20.9428C3.30724 21.1929 3.64638 21.3333 4 21.3333H25.3333C25.687 21.3333 26.0261 21.1929 26.2761 20.9428C26.5262 20.6928 26.6667 20.3536 26.6667 20V12.3152L22.2078 3.41031L22.206 3.40667C22.0956 3.18452 21.9254 2.99758 21.7146 2.86685C21.5039 2.73617 21.2608 2.66685 21.0129 2.66667H8.32045Z",
    fill: "#BCAB79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33331 17.3333C5.33331 16.597 5.93027 16 6.66665 16H6.67998C7.41636 16 8.01331 16.597 8.01331 17.3333C8.01331 18.0697 7.41636 18.6667 6.67998 18.6667H6.66665C5.93027 18.6667 5.33331 18.0697 5.33331 17.3333Z",
    fill: "#BCAB79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 17.3333C10.6667 16.597 11.2636 16 12 16H12.0134C12.7497 16 13.3467 16.597 13.3467 17.3333C13.3467 18.0697 12.7497 18.6667 12.0134 18.6667H12C11.2636 18.6667 10.6667 18.0697 10.6667 17.3333Z",
    fill: "#BCAB79"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataSourceIcon);
export default __webpack_public_path__ + "static/media/data-source-icon.b5335e57a9b3d76c032ac16ca9dac6c9.svg";
export { ForwardRef as ReactComponent };